import React, { useState } from "react";
import { Facebook, MessageCircle, Link2, Instagram, Share2, Check } from "lucide-react";
import { toast } from "sonner";

export const BlogShareBar = ({ post }) => {
  const [copied, setCopied] = useState(false);
  const slug = post.slug || post.id;
  const pageUrl = `${window.location.origin}/blog/${slug}`;
  const shareUrl = `${process.env.REACT_APP_BACKEND_URL}/api/blog/${slug}/share`;
  const text = `${post.title}${post.excerpt ? " — " + post.excerpt : ""}`;

  const copy = async (value, msg) => {
    try { await navigator.clipboard.writeText(value); setCopied(true); toast.success(msg); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error("Couldn't copy — long-press the link instead"); }
  };
  const native = async () => {
    if (navigator.share) { try { await navigator.share({ title: post.title, text: post.excerpt || "", url: pageUrl }); } catch (err) { if (err?.name !== "AbortError") console.warn("Share failed:", err?.message); } }
    else copy(pageUrl, "Link copied");
  };
  const btn = "inline-flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-widest border border-white/15 hover:border-white transition-colors";

  return (
    <div className="border-t border-white/10 pt-8 mt-12" data-testid="blog-share-bar">
      <div className="eyebrow mb-4">Share this story</div>
      <div className="flex flex-wrap gap-2">
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noreferrer" className={btn} data-testid="share-facebook"><Facebook size={14}/> Facebook</a>
        <a href={`https://wa.me/?text=${encodeURIComponent(text + " " + shareUrl)}`} target="_blank" rel="noreferrer" className={btn} data-testid="share-whatsapp"><MessageCircle size={14}/> WhatsApp</a>
        <button type="button" onClick={() => copy(`${text}\n\n${pageUrl}\n\n#2RightFeet #DanceSchool #HipHop`, "Caption + link copied — paste it into your Instagram story or post")} className={btn} data-testid="share-instagram"><Instagram size={14}/> Instagram caption</button>
        <button type="button" onClick={() => copy(pageUrl, "Link copied")} className={btn} data-testid="share-copy">{copied ? <Check size={14}/> : <Link2 size={14}/>} Copy link</button>
        <button type="button" onClick={native} className={btn} data-testid="share-native"><Share2 size={14}/> More</button>
      </div>
      <p className="text-zinc-500 text-xs mt-3">Facebook & WhatsApp previews use the post's cover image.</p>
    </div>
  );
};
